<template>
  <div class="container">
    <div class="row help-page justify-content-center text-center mt-4">
      <h1 class="mb-4">{{ $t("training.page_title") }}</h1>
      <div v-if="videos">
        <div v-for="(video, index) in videos" :key="index" class="">
          <h2>{{ video.topic }}</h2>
          <p>{{ video.description }}</p>
          <iframe
            :src="video.link"
            :title="iframeTitle(video)"
            class="shorter trainings-iframe centered-content-iframe"
          ></iframe>
        </div>
      </div>
      <div v-else>{{ $t("training.no_tutorials") }}</div>
    </div>
  </div>
</template>
<script>
import { onMounted, computed } from "vue"
import { useStore } from "vuex"
import { useI18n } from "vue-i18n"

export default {
  name: "TrainingVideo",
  setup() {
    const store = useStore()
    const { t } = useI18n()

    const videos = computed(() => store.getters["updates/videos"])

    const iframeTitle = (video) => {
      const topic = video?.topic?.trim?.()
      if (topic) {
        return t("training.video_iframe_title", { topic })
      }
      return t("training.page_title")
    }

    onMounted(() => {
      store.dispatch("updates/getVideos")
    })

    return {
      videos,
      iframeTitle
    }
  }
}
</script>
